import Slider from "react-slick";
import { useAuth, useStore } from "../hooks";
import Skeleton from "react-loading-skeleton";
import { ChevronLeft, ChevronRight } from "react-bootstrap-icons";
import CouponDetailModal from "./coupon/_modals/CouponDetailModal";
import { useState } from "react";
import { StoreCouponModel } from "../models";
import { sanitizeHtml, toAbsoluteUrl } from "../helpers";
import { useLayout } from "../context";
import { useNavigate } from "react-router-dom";

const settings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
  swipeToSlide: true,
  autoplay: true,
  autoplaySpeed: 4000,
  pauseOnHover: true,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      },
    },
  ],
  nextArrow: <RightArrow />,
  prevArrow: <LeftArrow />,
};

export const HomeBanners = () => {
  let navigate = useNavigate();

  const { isMenuLoading, storeCoupons } = useStore();
  const { setActiveModal } = useLayout();
  const { isLoggedIn, isGuest } = useAuth();

  const [selectedCoupon, setSelectedCoupon] = useState<StoreCouponModel>();
  const [show, setShow] = useState<boolean>(false);

  if (isMenuLoading) return <Skeleton height={120} className="mb-3" />;
  if (!storeCoupons?.length) return null;

  // const couponsToShow =
  //   storeCoupons.length === 1
  //     ? Array.from({ length: 3 }, () => storeCoupons[0])
  //     : storeCoupons;

  const isSingleCoupon = storeCoupons.length === 1;

  const handleBtnClick = (coupon: StoreCouponModel) => {
    setSelectedCoupon(coupon);
    setShow(true);
  };

  const handleLoginSignupClick = () => {
    if (isLoggedIn && !isGuest) {
      navigate("/menu");
      return;
    }

    setActiveModal("login");
  };

  return (
    <>
      <div className="home_banner mb-3">
        <div className="slider-container">
          <Slider {...settings}>
            {storeCoupons.map((coupon, index) => (
              <div key={index} className="slide-wrapper">
                <div className="slide-card d-flex align-items-center justify-content-start flex-row flex-nowrap mx-1">
                  <div className="slide-text" style={{ flex: "1 1 0%" }}>
                    <span className="slide-eyebrow">{coupon.code}</span>
                    <h3 className="my-1 slider-heading">{coupon.title}</h3>
                    <p
                      className="slider-desc"
                      dangerouslySetInnerHTML={{
                        __html: sanitizeHtml(coupon.description),
                      }}
                    />
                    <button
                      className="btn slide-btn"
                      onClick={() => handleBtnClick(coupon)}
                    >
                      Know more
                    </button>
                  </div>
                  <div className="slide-image-wrapper">
                    {coupon.image && (
                      <img
                        src={coupon.image}
                        alt={coupon.title}
                        className="slide-banner-img"
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}

            {isSingleCoupon && (
              <div className="slide-wrapper">
                <div className="slide-card d-flex align-items-center justify-content-start flex-row flex-nowrap mx-2">
                  <div className="slide-text" style={{ flex: "1 1 0%" }}>
                    <span className="slide-eyebrow">Special Offer</span>
                    <h3 className="my-1 slider-heading">
                      Unlock Exclusive Deals
                    </h3>
                    <p className="slider-desc">
                      Login or sign up to get started{" "}
                    </p>
                    <button
                      className="btn slide-btn"
                      onClick={handleLoginSignupClick}
                    >
                      {isLoggedIn && !isGuest
                        ? "Explore Menu"
                        : "Login / Signup"}
                    </button>
                  </div>
                  <div className="slide-image-wrapper">
                    <img
                      src={toAbsoluteUrl("images/login_signup.png")}
                      alt="Login or sign up"
                      className="slide-banner-img"
                    />
                  </div>
                </div>
              </div>
            )}
          </Slider>
        </div>
      </div>

      {selectedCoupon && (
        <CouponDetailModal
          show={show}
          coupon={selectedCoupon}
          handleClose={() => setShow(false)}
        />
      )}
    </>
  );
};

function LeftArrow(props: any) {
  const { className, style, onClick } = props;
  return (
    <button
      className={`${className} rounded-circle`}
      style={{ ...style }}
      onClick={onClick}
    >
      <ChevronLeft size={20} />
    </button>
  );
}

function RightArrow(props: any) {
  const { className, style, onClick } = props;
  return (
    <button
      className={`${className} rounded-circle`}
      style={{ ...style }}
      onClick={onClick}
    >
      <ChevronRight size={20} />
    </button>
  );
}

export default HomeBanners;
